import moment from 'moment'
import { useSelector } from 'react-redux'
import { Feature, useFeatureFlag } from '@src/components/FeatureFlag'
import { useGetAllOwnSensorSubscriptions } from '@src/hooks/useHasOwnSensorSubscription'
import { insurancePolicySelector } from '@src/screens/NutritionistHub/models/nutritionistHub.selectors'
import { userSelector } from '@src/selectors/app'
import { sensorSelector } from '@src/selectors/sensor'
import { Storage } from '@src/utils'
import { useVideoCallProductType } from '@src/hooks/useVideoCallProductType.ts'

export const useShouldShowOwnSensorActivatedVideoCallUpsellModal = () => {
  const activeOwnSensorSubscriptions = useGetAllOwnSensorSubscriptions()
  const sensor = useSelector(sensorSelector)
  const modalDisplayEnabled = useFeatureFlag(Feature.OwnSensorActivatedVideoCallsUpsell)
  const insurancePolicy = useSelector(insurancePolicySelector)
  const user = useSelector(userSelector)
  const { isInsuranceVideoCallProductType } = useVideoCallProductType()
  const modalCompleted = Storage.get(
    `${Storage.OWN_SENSOR_ACTIVATED_VIDEO_CALL_UPSELL_MODAL_COMPLETED_KEY}_${user?.id}`,
    false,
  )

  if (
    !modalDisplayEnabled ||
    modalCompleted ||
    insurancePolicy ||
    activeOwnSensorSubscriptions.length === 0 ||
    !sensor ||
    !sensor.createdAt ||
    !isInsuranceVideoCallProductType
  ) {
    return false
  }

  const minutesAfterSensorCreation = moment().diff(sensor.createdAt, 'minutes')
  const oneDayInMinutes = 24 * 60

  return minutesAfterSensorCreation < oneDayInMinutes
}
